module.exports = {"500232100":"巷口镇","500232101":"火炉镇","500232102":"白马镇","500232103":"鸭江镇","500232104":"长坝镇","500232105":"江口镇","500232106":"平桥镇","500232107":"羊角镇","500232108":"仙女山镇","500232109":"桐梓镇","500232110":"土坎镇","500232111":"和顺镇","500232112":"双河镇","500232200":"凤来乡","500232202":"庙垭乡","500232203":"石桥苗族土家族乡","500232205":"黄莺乡","500232206":"沧沟乡","500232207":"文复苗族土家族乡","500232208":"土地乡","500232209":"白云乡","500232210":"后坪苗族土家族乡","500232211":"浩口苗族仡佬族乡","500232212":"接龙乡","500232213":"赵家乡","500232214":"大洞河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500232.json
// module id = 2371
// module chunks = 0